<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Seguimiento </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div class="d-flex align-center">
          <v-text-field
            v-model="search"
            label="Buscar..."
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div class="d-flex align-center">
          <v-btn
            v-if="permission.descragar"
            icon
            v-bind="props"
            color="indigo-darken-3"
            class="mr-2 reload"
            @click="exportToExcel"
          >
            <v-tooltip activator="parent" location="top"
              >Exportar Datos</v-tooltip
            >
            <v-icon>mdi-file-table</v-icon>
          </v-btn>

          <v-text-field
            type="date"
            label="Feha Inicio"
            variant="outlined"
            class="mr-2"
            v-model="dateStart"
            v-if="permission.buscarVisualizar"
          ></v-text-field>
          <v-text-field
            type="date"
            label="Fecha Fin"
            variant="outlined"
            class="mr-2"
            v-model="dateEnd"
            v-if="permission.buscarVisualizar"
          ></v-text-field>
          <v-btn
            @click="searchPerDate"
            v-if="permission.buscarVisualizar"
            color="indigo-darken-3"
            class="text-none mb-4"
            >Buscar</v-btn
          >
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headersTable"
          :items="listPT"
          :search="search"
          :loading="loading"
        >
          <template v-slot:[`item.id_cliente`]="{ item }">
            <a @click="redirectClient(item.id_cliente)" target="_blank" style="cursor: pointer; color: blue;">
              {{ item.id_cliente }}
            </a>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>
</template>

<script>
import { ProjectTraking } from "@/services/ProjectTraking";
//import { ResourcesService } from '@/services/ResourcesService'
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";
import { EncryptService } from "@/services/EncryptService";

export default {
  name: "ProjectTrackingComponent",
  props: {
    msg: String,
  },
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      headersTable: [
        { title: "Cliente Único", text: "Cliente Único", value: "id_cliente" },
        { title: "Nombre Cliente", text: "Nombre Cliente", value: "nombre" },
        { title: "Gestor", text: "Gestor", value: "username" },
        { title: "Colaboración", text: "Colaboración", value: "colaborador" },
        { title: "Fecha de Contacto", text: "Fecha de Contacto", value: "fecha_hora_contactar" },
        { title: "Estatus", text: "Estatus", value: "estatus" },
        { title: "Comentarios", text: "Comentarios", value: "comentario" },
      ],
      search: "",
      loading: false,
      listPT: [],
      timezone: "America/Mexico_City",
      dateStart: null,
      dateStartVista: null,
      dateEnd: null,
      dateEndVista: null,
      customNoDataText: "No hay datos disponibles",
      footerPager: "Elementos por página",
      listNueva: [],
      language: "es",
      permission: {
        buscarVisualizar: false, //M03F01BVPL
        descragar: false, //M03F02DTPF
      },
    };
  },
  async created() {
    const ENC_PERMISOS = localStorage.getItem("PERMISOS");
    const STR_PERMISOS = atob(ENC_PERMISOS);
    const ARR_PERMISOS = JSON.parse(STR_PERMISOS);
    const PERMISSION = ARR_PERMISOS.find(
      (permission) => permission.modulo === "M03SEGU"
    );
    for (const element of PERMISSION.endpoints) {
      if (element.nombre === "M03F01BVPL" && element.permiso === true) {
        this.permission.buscarVisualizar = true;
      }
      if (element.nombre === "M03F02DTPF" && element.permiso === true) {
        this.permission.descragar = true;
      }
    }
  },
  beforeMount() {},
  methods: {
    getProjectTraking: async function () {
      let arrFecha = this.date.split("-");
      let fechaFormateada = arrFecha[2] + "/" + arrFecha[1] + "/" + arrFecha[0];

      await ProjectTraking.getProjectTraking(fechaFormateada)
        .then((resp) => {
          if (!resp.error) {
            this.listPT = resp.response;
            this.listPT.forEach((ele) => {
              if (ele.estatus == null) {
                ele.estatus = "Sin estado";
              }
            });
            this.listNueva = this.listPT;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    searchPerDate: async function () {
      let arrFechaI = this.dateStart.split("-");
      let fechaInicio = arrFechaI[2] + "-" + arrFechaI[1] + "-" + arrFechaI[0];

      let arrFechaF = this.dateEnd.split("-");
      let fechaFin = arrFechaF[2] + "-" + arrFechaF[1] + "-" + arrFechaF[0];
      this.loading = true;
      await ProjectTraking.getProjectTrakingPerDates(fechaInicio, fechaFin)
        .then((resp) => {
          if (!resp.error) {
            this.listPT = resp.response;
            this.listPT.forEach((ele) => {
              if (ele.estatus == null) {
                ele.estatus = "Sin estado";
              }
            });
            setTimeout(() => {
              this.loading = false;
            }, 2000);
            this.listNueva = this.listPT;
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    exportToExcel: async function () {
      const formData = new FormData();
      formData.append("data", JSON.stringify(this.listNueva));

      await ProjectTraking.reporte(formData)
        .then((resp) => {
          if (!resp.error) {
            window.location.href = resp.url;
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    redirectClient: async function (id_cliente) {
      const form = {
        id: id_cliente,
      };
      const strForm = JSON.stringify(form);
      const encForm = await EncryptService.encrypt(strForm);

      const newWindow = window.open(
        this.$router.resolve({
          path: `/SGCCV/access-search-management/${encForm}/general`,
        }).href,
        "_blank"
      );
      if (newWindow) {
        newWindow.focus();
      }
    },
  },
};
</script>

<style scoped>
.div {
  height: 81vh;
  overflow: auto;
}
.content_main {
  padding-top: 20px;
}

.card {
  max-width: 180vh;
  max-height: 75vh;
  margin: 8vh;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.searching {
  width: 50vh;
}

.export {
  margin-top: 2vh;
  margin-left: 32vh;
  float: left;
}

.dates {
  float: left;
  margin: 1vh;
}

.btn-searhc {
  float: left;
  margin-top: 3vh;
  margin-right: 3vh;
}

th {
  position: sticky;
  top: 0;
  background-color: #f8f8f8; /* Color de fondo del encabezado fijo */
  /* Puedes ajustar otros estilos según tus necesidades */
}

.content_table {
  overflow: auto;
  height: 52vh;
}

.reload {
  margin-top: -2vh;
}
</style>
